import useTranslation from 'next-translate/useTranslation'
import Select from 'react-select'
import { useState } from 'react'
import Link from 'next/link'
import Tippy from '@tippyjs/react'
import { RoleData } from '@/data/roleData'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'tippy.js/dist/tippy.css'
import Breadcrumbs from '../atoms/Breadcrumbs'

interface IProps {
  data: RoleData[]
}

const SalaryIndexTemplate = ({ data }: IProps) => {
  const { t, lang } = useTranslation('it_report')
  const [value, setValue] = useState(null)
  const options = data.map((role: RoleData) => ({
    value: role.slug,
    label: role[`position_${lang}` as keyof RoleData],
    searchTerms: `${role.values.join(' ')}`,
  }))

  const filterOptions = (
    option: { label: string; value: string; data: any },
    input: string
  ) => {
    if (input) {
      return input.split(' ').every((term) => {
        const regex = new RegExp(term, 'i')
        return regex.test(option.data.searchTerms)
      })
    }

    return true
  }

  const onChange = (option: any) => {
    if (option) {
      setValue(option.value)
    } else {
      setValue(null)
    }
  }

  const onClick = () => {
    window.location.href = `/it-report/salaries/${value}`
  }

  const customStyles = {
    dropdownIndicator: (provided: any) => ({
      ...provided,
      background: '#EC602B',
      padding: '12px 20px',
      color: 'white',
      transition: 'all 0.3s ease',
      '&:hover': {
        background: '#CD400B',
        color: 'white',
      },
    }),
    placeholder: (provided: any) => ({
      ...provided,
      fontWeight: 'medium',
    }),
    control: (provided: any) => ({
      ...provided,
      borderRadius: '50px',
      overflow: 'hidden',
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      fontWeight: 'bold',
      paddingLeft: '20px',
    }),
    indicatorSeparator: (provided: any) => ({
      ...provided,
      display: 'none',
    }),
  }
  return (
    <>
      <main className='bg-gray-bg py-4'>
        <div className='container container-medium h-full'>
          <Breadcrumbs
            data={[
              { title: t('salary-breadcrumbs-all'), url: '/it-report' },
              { title: t('salary-breadcrumbs-salary-index') },
            ]}
          />

          <div className=' md:my-32 my-12'>
            <h1 className='mt-10 text-4.5xl w-full text-center'>
              {t('salary-index-title')}
            </h1>
            <div className='py-12 pb-6 flex flex-col md:flex-row md:justify-center items-stretch gap-4'>
              <Select
                options={options}
                isSearchable
                isClearable
                filterOption={filterOptions}
                onChange={onChange}
                className='w-full md:w-1/2 text-2xl'
                placeholder={t('salary-choose')}
                noOptionsMessage={() => t('salary-no-results')}
                styles={customStyles}
              />
              <Tippy content={t('salary-choose-first')} disabled={!!value}>
                <div>
                  <button
                    type='button'
                    disabled={!value}
                    onClick={onClick}
                    className='bg-primary px-12 py-4 text-white rounded-full text-2xl font-bold duration-300 hover:bg-primary-hover disabled:cursor-not-allowed disabled:grayscale w-full'
                  >
                    {t('salary-see-data')}
                  </button>
                </div>
              </Tippy>
            </div>
          </div>
        </div>
      </main>
      <section className='bg-action py-4'>
        <div className='container container-medium h-full my-10'>
          <h2 className='mt-10 text-3xl text-white'>
            {t('salary-all-roles')}{' '}
          </h2>
          <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 text-white my-12'>
            {data.map((role) => (
              <Link href={`/it-report/salaries/${role.slug}`}>
                {role[`position_${lang}` as keyof RoleData]}
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default SalaryIndexTemplate
